// extracted by mini-css-extract-plugin
export default {"buttonColumn":"Localization_buttonColumn__5KF1x"};